import React, { useContext, useState } from "react";
import { Button } from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";
// import { LclDataContext } from "../Contexts/LclDataContext";
// import { ParcelDataContext } from "../Contexts/ParcelDataContext";
// import { LinehaulFixedDataContext } from "../Contexts/LinehaulFixedDataContext";
// import { LinehaulFloatingDataContext } from "../Contexts/LinehaulFloatingDataContext";
// import { HourlyDataContext } from "../Contexts/HourlyDataContext";
import PropTypes from "prop-types";
import { getDateFromWeekAndDay, getWeekDates } from "../GlobalFunctions";
import { AppStateContext } from "../Contexts/AppStateContext";

const axios = require("axios");

function ButtonEdit(props) {
  const {
    controller,
    truckId,
    week,
    day,
    itemData,
    itemId,
    onClick,
    callback,
    files,
    disabled,
    ...otherProps
  } = props; //filter out onClick
  const { userData, setUserData } = useContext(UserDataContext);
  // const { dispatch: dispatchLcl } = useContext(LclDataContext);
  // const { dispatch: dispatchParcel } = useContext(ParcelDataContext);
  // const { dispatch: dispatchLinehaulFixed } = useContext(
  //   LinehaulFixedDataContext
  // );
  // const { dispatch: dispatchLinehaulFloating } = useContext(
  //   LinehaulFloatingDataContext
  // );
  // const { dispatch: dispatchHourly } = useContext(HourlyDataContext);
  const [loading, setLoading] = useState(false);

  const { setScrollPosition } = useContext(AppStateContext);
  const handleClick = () => {
    setScrollPosition();
    sendRequest();
  };

  const sendRequest = async () => {
    const newItemData = itemData;
    // const newItemData = { ...itemData, routeId: Number(itemData.routeId), id: itemId };

    const request = {
      method: "POST",
      url: `${controller}/change/`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: newItemData,
    };
    const { startDate, endDate } = getWeekDates(week);
    const requestStatus = {
      method: "GET",
      url: `/invoices/getState/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}/${week}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      setLoading(true);
      await axios(request);
      await sendUploadRequest(itemId);

      const res = await axios(requestStatus);
      let invoiceStatuses = userData.invoiceStatuses;
      invoiceStatuses[truckId][week] = res.data.invoiceState;
      setUserData({ ...userData, invoiceStatuses });
      // const action = {
      //   type: "UPDATE_ITEM",
      //   truckId,
      //   week,
      //   day,
      //   itemData: newItemData,
      //   roleId: userData.roleId,
      //   itemId,
      // };
      // controller === "lcls" && dispatchLcl(action);
      // controller === "parcels" && dispatchParcel(action);
      // controller === "rates" && dispatchHourly(action);
      // controller === "linehauls" && dispatchLinehaulFixed(action);
      // controller === "floating" && dispatchLinehaulFloating(action);

      // setLoading(false);
      // callback();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const sendUploadRequest = async (id) => {
    setLoading(true);
    const promises = files.map((file) => {
      const fileData = new FormData();
      fileData.append("file", file);
      const request = {
        method: "POST",
        url: `files/UploadAsync/${id}/${
          getDateFromWeekAndDay(week, day).dateIsoString
        }`,
        headers: {
          Authorization: `bearer ${userData.token}`,
        },
        data: fileData,
      };
      console.log(request);
      return axios(request);
    });

    Promise.all(promises)
      .then((res) => res)
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  return (
    <Button
      onClick={handleClick}
      {...otherProps}
      disabled={loading || disabled}
    >
      save change
    </Button>
  );
}

export default ButtonEdit;

ButtonEdit.propTypes = {
  controller: PropTypes.string.isRequired,
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemData: PropTypes.object.isRequired,
  itemId: PropTypes.string.isRequired,
};
